import { type FC, useEffect } from 'react';
import classnames from 'classnames';
import { graphql, useFragment } from 'react-relay';

import Time from 'dibs-icons/exports/Time.ts';

import { useSellerAwayCopy } from '../../hooks/useSellerAwayCopy.ts';
import {
    trackSellerTimeAwayDisplayed,
    type SellerTimeAwayTrackingTrigger,
} from '../../tracking/trackSellerTimeAwayDisplayed.ts';

import { type SellerAwayBanner_seller$key } from './__generated__/SellerAwayBanner_seller.graphql.ts';

import dibsCss from 'dibs-css';

const sellerFragment = graphql`
    fragment SellerAwayBanner_seller on Seller {
        ...useSellerAwayCopy_seller
    }
`;

const SellerAwayBanner: FC<{
    seller: SellerAwayBanner_seller$key | null | undefined;
    messageType: 'compact' | 'regular';
    trackingTrigger?: SellerTimeAwayTrackingTrigger;
}> = ({ seller: sellerRef, messageType, trackingTrigger }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const sellerAwayCopy = useSellerAwayCopy({ seller, messageType });

    useEffect(() => {
        if (sellerAwayCopy && trackingTrigger) {
            trackSellerTimeAwayDisplayed(trackingTrigger);
        }
    }, [sellerAwayCopy, trackingTrigger]);

    if (!sellerAwayCopy) {
        return null;
    }

    return (
        <div
            data-tn="seller-time-away-banner"
            className={classnames(
                dibsCss.flex,
                dibsCss.mt0,
                dibsCss.mb3px,
                dibsCss.gapXsmall,
                dibsCss.itemsCenter,
                dibsCss.bgYellow100,
                dibsCss.roundedXxsmall,
                dibsCss.pSmaller,
                dibsCss.textBodySmallNormal,
                dibsCss.itemsStart
            )}
        >
            <div
                className={classnames(dibsCss.flexShrink0, {
                    [dibsCss.mbSmall]: messageType !== 'compact',
                })}
            >
                <Time variation="20" />
            </div>
            {sellerAwayCopy}
        </div>
    );
};

export { SellerAwayBanner };
